module.exports = __webpack_public_path__ + "files/2ae1e5da3b15f41bfb8484dbde345fb7.png";